module.exports = __webpack_public_path__ + "24a0c8d0582bb4ed578626395c804b73.png";